export const rpAwinInit = () => {
    const awMastertag = document.createElement("script");
    awMastertag.setAttribute("defer", "defer");
    awMastertag.src = "https://www.dwin1.com/116705.js";
    awMastertag.type = "text/javascript";
    document.body.appendChild(awMastertag);

    const linkParams = new URLSearchParams(window.location.search);

    if (linkParams.has("awc")) {
        const checkCookieInterval = setInterval(() => {
            const awinCookie = document.cookie
                ?.split(";")
                ?.filter((cookie) => cookie.includes("_aw_") && cookie.split("=")[1][0] !== "{")[0]
                ?.split("=");
            const userSessionCookieValue = document.cookie
                ?.split(";")
                ?.filter((cookie) => cookie.includes("usersessionid"))[0]
                ?.split("=")[1];

            if (awinCookie && userSessionCookieValue) {
                document.cookie = `awin=${JSON.stringify({value: awinCookie[1], userSession: userSessionCookieValue, name: awinCookie[0]})}; path=/`;
                clearInterval(checkCookieInterval);
            }
        }, 500);
    }
};
